import "../marketing/analytics";
import "../suggestions/suggestions-plans";

import modal from "../modal";
import MottoView from "../components/motto";
import "../suggestions/demo";
import tabs from "../components/tabs";
import urls from "../urls";

const $ = window.jQuery;
const { settings } = window.DA;

const ADDRESS_DEMO_QUERY = "мск сухонская 11 89";
const PARTY_DEMO_QUERY = "моторика сколково";

function SetVueAppEvent($link, href, queryText) {
    const $demo = $("#demo"); // Suggestions demo vue app container
    const $input = $(`${href}-input`); // #address-input
    $link.on("click", e => {
        e.preventDefault();
        $demo.find(`.plaintabs__header a[href='${href}']`)
            .click();

        if (!$input.val() === queryText) {
            $input.suggestions()
                .clear();
        }

        const event = new CustomEvent(`${href.slice(1)}-change`, { detail: { value: queryText } });
        document.dispatchEvent(event);

        $demo.get(0)
            .scrollIntoView();
        $input.focus();
    });
}

function ClickToDemo() {
    SetVueAppEvent(
        $("#do-demo"),
        "#address",
        ADDRESS_DEMO_QUERY,
    );

    SetVueAppEvent(
        $("#do-demo-party"),
        "#party",
        PARTY_DEMO_QUERY,
    );
}

function WhatIsQuery() {
    $("#try")
        .find("a[href='#query']")
        .on("click", e => {
            e.preventDefault();
            $("#query")
                .removeClass("hidden");
        });
}

function Platforms($el) {
    const $popular = $el.find(".js-popular");
    const $all = $el.find(".js-all");
    const $showAll = $el.find(".js-show-all");
    $showAll.click(() => {
        $popular.hide();
        $all.fadeIn();
    });
    if (window.location.hash === "#platforms-all") {
        $showAll.trigger("click");
    }
}

$(() => {
    const $isSubscribedCheckboxes = $(
        "#id_anon-sug-shpis_subscribed_checkbox, #id_None-shpis_subscribed_checkbox",
    );
    const $isSubscribedInputs = $("#id_anon-sug-shpis_subscribed, #id_shpis_subscribed");
    $isSubscribedCheckboxes.on("ifChecked", () => {
        $isSubscribedInputs.val("yes");
    });
    $isSubscribedCheckboxes.on("ifUnchecked", () => {
        $isSubscribedInputs.val("no");
    });
    $("#id_anon-sug-Email, #id_cps_email")
        .suggestions({
            serviceUrl: urls.api.demo.getUrl(),
            token: settings.API_KEY,
            type: "EMAIL",
            count: 5,
            hint: "",
            suggest_local: false,
        });

    tabs.create($(".plaintabs"));
    tabs.showActiveTab();
    MottoView(tabs);

    Platforms($("#platforms"));
    ClickToDemo();
    WhatIsQuery();

    modal.attach();
});

export default {};
